<template>
    <div class="migrationMap">
        <Header @getLoginInfo="getLoginInfoFn"></Header>

        <!-- 面包屑 -->
        <div style="width:100%;overflow:hidden;">
            <div class="underHeader">
                <img :src="local" style="width:12px;display:inline-block;"/>
                当前位置：
                <a href="/#/index">平台首页 ></a>
                迁移分析
            </div>
        </div>
        
        <el-container style="height: 900px;margin: 0 auto 21px;width:98%;background: rgba(5, 43, 79, 0.3);border: 1px solid #08396A;border-radius: 2px;">
            
            <allMap :loginInfo="loginInfo"></allMap>
           
        </el-container>
        <Footer style="margin-top:25px;"></Footer>
    </div>
</template>
<script>

import echarts from 'echarts';
import $ from 'jquery';

import Header from "@/components/header";
import Footer from "@/components/footer";
import allMap from "@/components/allMap/index"

import local from "@/assets/map/local.png";

export default {
    data() {
        let _self = this;
        return {
            loginInfo:'',//登录信息
            local
        };
    },
    components:{
        Header,
        Footer,
        allMap
    },
    methods: {
        //获取header返回来的登录信息
        getLoginInfoFn(val) {
            console.log(val,'val')
            this.loginInfo = val;
        }
    },
    mounted() {
        
    },
  
};
</script>
<style scoped lang="less">
.migrationMap {
    width: 100%;
    height: 100%;
    background: url('../../assets/map/bg.jpg') no-repeat top;
    background-size: 100% auto;
}
// 面包屑样式
.underHeader{
    display: inline-block;
    height: 55px;
    line-height: 55px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #DFECF7;
    margin-left:20px;
    overflow: hidden;
    a{
        color: #DFECF7;
    }
}


</style>


// WEBPACK FOOTER //
// src/view/migrationMap/index.vue